/**
 * Created by jv on 16/01/2017.
 */
const utils = require("Sources/utils/utils");

var request = {};

(function(Request)
{
  Request.get = function(options, successCb, failCb)
  {
    options.type = "GET";
    doRequest(options, successCb, failCb);
  };

  Request.post = function(options, successCb, failCb)
  {
    options.type = "POST";
    doRequest(options, successCb, failCb);
  };

  Request.put = function(options, successCb, failCb)
  {
    options.type = "PUT";
    doRequest(options, successCb, failCb);
  };

  function doRequest(options, successCb, failCb)
  {
    var startTime = Date.now();
    utils.devLog("Request:\nmethod: %s\nurl: %s,\ndata: %o", options.type, options.url, options.data);

    // Download / Upload progress
    if(utils.isFunction(options.onProgress) || utils.isFunction(options.onUploadProgress))
    {
      options.xhr = function()
      {
        var xhr = new window.XMLHttpRequest();

        if(utils.isFunction(options.onUploadProgress))
        {
          xhr.upload.addEventListener("progress", function(evt)
          {
            if(evt.lengthComputable)
            {
              var percentComplete = evt.loaded / evt.total;
              options.onUploadProgress(percentComplete);
            }
          }, false);
        }

        if(utils.isFunction(options.onProgress))
        {
          xhr.addEventListener("progress", function(evt)
          {
            if(evt.lengthComputable)
            {
              var percentComplete = evt.loaded / evt.total;
              options.onProgress(percentComplete);
            }
          }, false);
        }

       return xhr;
      };
    }

    // Request (order matters! in this case: always -> done / fail)
    $.ajax(options)
    .always(function(data, textStatus)
    {
      if(__DEVELOPMENT__)
      {
        var executeTime = Date.now() - startTime;
        executeTime = (executeTime / 1000) + "s";

        var css = "background-color: #222;color: #bada55;";
        console.log("%cRequest complete%c\nurl: %s\nMethod: %s\nStatus: %s\nExecute time: %s\nResult: %o",
              /*empty string to reset css*/
                    css, "", options.url, options.type, textStatus, executeTime, data);
      }
    })
    .done(function(data)
    {
      if(utils.isFunction(successCb) && !data.hasOwnProperty("exception"))
      {
        successCb(data);
      }
      else if(utils.isFunction(failCb) && data.hasOwnProperty("exception"))
      {
        failCb(data);
      }
    })
    .fail(function(data)
    {
      if(utils.isFunction(failCb))
      {
        failCb(data);
      }
    });
  }
}(request));

module.exports = request;



// WEBPACK FOOTER //
// ./app/js/services/request.js